<template>
  <v-card max-width="600" class="mx-auto">
    <v-card-text>
      <v-alert
      outlined
      type="success"
      text
    >
      <p>Your email has been successfully verified</p>
      You can now <router-link to="/login">Login</router-link> to your account.
    </v-alert>
    </v-card-text>
  </v-card>
</template>

<script>
export default {

}
</script>

<style>

</style>